import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-requestblock',
  templateUrl: './requestblock.component.html',
  styleUrls: ['./requestblock.component.scss']
})
export class RequestblockComponent implements OnInit {
  @Input()
  requestData: any;
  @Input()
  index;
  @Output() eventId = new EventEmitter();

  accounts;
  fromDate;
  toDate;
  constructor() { }

  ngOnInit() {
    this.setRequestData();
  }
  setRequestData() {
    if (this.requestData) {
      // this.accounts = this.requestData.Account.accountTypes.split(/\s*,\s*/);
      // this.accountCount=this.accounts.length?this.accounts.length-1:1;
      this.fromDate = new Date(this.requestData.timeStamp);
      this.toDate = new Date(this.fromDate);
      // if (this.requestData["Data-Items"][0].Frequency.unit == "MONTHLY") {
        this.toDate.setMonth(this.fromDate.getMonth() + 1);
      // }
    }
  }
  outputEvent(){
    this.eventId.emit(this.requestData.eventID);
  }
}
